import toastManager from "../toastManager";

export const validateAllowCalculation = ({
  computeRequired = false,
  recomputeAllowed = false,
}) => {
  const allowCalculation = computeRequired || recomputeAllowed;

  if (!allowCalculation) {
    toastManager(
      "warning",
      "Re-Calculation not Required",
      "Calculation has already been performed with these images and parameters."
    );
  }

  return allowCalculation;
};
